import {createFeatureSelector, createSelector} from "@ngrx/store";
import {DbStoreState} from "../reducers";
import {IEcommerceEntityState} from "../reducers/ecommerce.reducer";

const getDbStoreState = createFeatureSelector<DbStoreState>('dbStore');

export const getEcommerceState = createSelector(getDbStoreState, (dbStoreState: DbStoreState) => dbStoreState.ecommerce);
export const getEcommerceProductsState = (websiteId: number) =>
  createSelector(getDbStoreState, (dbStoreState: DbStoreState) => dbStoreState.ecommerce.entities[websiteId]);

export const getProducts = (websiteId: number) => createSelector(getEcommerceProductsState(websiteId),
  (state: IEcommerceEntityState) => state
);

export const getProductsLoading = (websiteId: number) => createSelector(getEcommerceProductsState(websiteId),
  (state: IEcommerceEntityState) => state && state.loading
);

export const getProductsLoaded = (websiteId: number) => createSelector(getEcommerceProductsState(websiteId),
  (state: IEcommerceEntityState) => state.loaded
);
